module.exports = __webpack_public_path__ + "static/bg-1-00180d20e7d8c4e4648677fff90d914c.png";